import { parse } from 'qs';
import { ClassAttributes, createElement, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import _ShowCreationPage from '../page/ShowCreationPage';

type UrlParams = {
  creationId: string;
};

type Props = ClassAttributes<HTMLElement> & RouteComponentProps<UrlParams>;

const ShowCreationPage = ({ match }: Props) => {
  const dependency = useContext(DependencyContext);
  const state = useContext(StateContext);

  const { modification_request_issue: selectedModificationRequestIssueId } = parse(state.location.search.slice(1));
  const { modification_request: selectedModificationRequestId } = parse(dependency.history.location.search, {
    ignoreQueryPrefix: true,
  });

  return (
    <RouteLifecycleWrapper
      onMount={async () => {
        dependency.authenticationUsecase.needSignedIn();
      }}
      onUnmount={() => {}}
    >
      <_ShowCreationPage
        creationId={match.params.creationId}
        selectedModificationRequestIssueId={selectedModificationRequestIssueId}
        selectedModificationRequestId={selectedModificationRequestId}
        language={state.language}
        prepareProject={async (projectId: string) => {
          await dependency.showProjectUsecase.prepare(projectId);
        }}
      />
    </RouteLifecycleWrapper>
  );
};

export default ShowCreationPage;
